module.exports = __webpack_public_path__ + "public/Icons/menu@2x.png?46a78c4c";